import React from 'react';
import Modal from '../../../../../components/Modal';
import ProductDetailPayMethodTypeInfo from '../../productDetail/ProductDetailPayMethodTypeInfo';
import './ProductPayMethodTypeEditConfirmModal.scss';

const ProductPayMethodTypeEditConfirmModal = (props) => {
  const { isOpen, data, closeModal, onSubmit } = props;
  const { beforePayMethodTypeInfo, editPayMethodTypeInfo } = data;

  return (
    <Modal
      title="상품 결제타입 변경 확인"
      isOpen={isOpen}
      width={1000}
      height={400}
      isFooter={true}
      okText="저장"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="product-pay-method-type-edit-confirm-modal-wrap">
        <div className="summary">아래와 같이 결제 수단을 변경하는 것이 맞는지 확인 후 저장해주시기 바랍니다.</div>

        <div className="product-pay-method-info-container">
          <div className="product-pay-method-info">
            <div className="title">변경전</div>

            <div className="content">
              <ProductDetailPayMethodTypeInfo
                productPayMethodTypeId={beforePayMethodTypeInfo.productPayMethodTypeId}
                productPayMethodList={beforePayMethodTypeInfo.productPayMethodList}
                card={beforePayMethodTypeInfo.card}
              />
            </div>
          </div>
          <div className="product-pay-method-info">
            <div className="title">변경후</div>

            <div className="content">
              <ProductDetailPayMethodTypeInfo
                productPayMethodTypeId={editPayMethodTypeInfo.productPayMethodTypeId}
                productPayMethodList={editPayMethodTypeInfo.productPayMethodList}
                card={editPayMethodTypeInfo.card}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProductPayMethodTypeEditConfirmModal;
